export const OrderType = Object.freeze({
  PurchaseOrder: 1,
  TransferenceOrder: 2,
  PurchaseOrderReturnableAssets: 3
});
